// importeer hier alle scripts die je maakt

import "./utils/boxSizing.js";
import "./alpine/alpine.js";
import "./animations/animations.js";
import "./components/count-up.js";
import "./components/language-switcher.js";
import "./components/formie.js";

// Lenis stond wel in package.json en het component was volledig uitgewerkt,
// maar werd nergens geïmporteerd: er was dus geen smooth scroll en een
// ankerklik sprong hard. De ankerlogica zit in dat bestand zelf, dus dit is de
// enige regel die nodig was.
import "./components/lenis.js";

// VOORWAARDELIJKE IMPORTS
//
// Alles hieronder weegt zwaar en staat maar op een deel van de pagina's. Een
// dynamische `import()` maakt er een eigen bestand van dat Vite pas ophaalt als
// de pagina het element heeft. De kaart stond hier al zo; Swiper en Fancybox
// zijn erbij gekomen. Gemeten aan de bundel (bron, via de sourcemap):
// Swiper 185 KB, Fancybox 122 KB, samen 63% van app.js. Swiper staat op vier
// blokken, Fancybox op drie templates; de meeste pagina's hebben geen van beide.

// De kaart weegt ruim een megabyte aan JS en CSS. Alleen ophalen op een pagina
// die er een heeft; leaflet-map.js zoekt zelf op [data-map].
if (document.querySelector("[data-map]")) {
    import("./components/leaflet-map.js");
    import("leaflet/dist/leaflet.css");
    import("leaflet.markercluster/dist/MarkerCluster.css");
    import("leaflet.markercluster/dist/MarkerCluster.Default.css");
}

// Dezelfde drie klassen als in components/swiper.js, waar de sliders opgestart
// worden. Komt daar een vierde bij, dan moet die hier ook staan, anders start
// die slider niet. Niet op `.swiper` gegokt: de kaarten-slider zet zijn
// pijlknoppen buiten dat element en de tijdlijn gebruikt Swiper juist niet.
const SLIDERS = ".images-slider, .cards-slider, .text-media-slider";
if (document.querySelector(SLIDERS)) {
    import("./components/swiper.js");
}

// Fancybox: enkel op blog- en realisatiedetail en op de beeldenslider. De
// attributen komen uit _components/asset.twig, dat `data-fancybox` zet of
// `data-fancybox-delegate` in de thumbnailvariant.
if (document.querySelector("[data-fancybox], [data-fancybox-delegate]")) {
    import("./components/fancybox.js");
}

import "./components/line-travel.js";
import "./vendor/iubenda.js";
import "./vendor/ga-slug.js";
import "./helpers/lazyImgs.js";
